export default {
  methods: {
    formatNumber(val) {
      let output = "";

      val = ( typeof val === 'number' ) ? val.toString().split(",").join("") : val

      while (val.length >= 3) {
        const last3Digits = val.slice(val.length - 3, val.length);
        val = val.slice(0, val.length - 3);
        output = "," + last3Digits + output;
      }
      if (val.length === 0) {
        output = output.slice(1, output.length);
      } else {
        output = val + output;
      }

      if (output.slice(0, 2) == '-,' ) {
        output = output.replace('-,', '- ')
      }
      return output;
    }
  }  
}